import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PaymentOperationListItem } from '@/models/dictionary/payment-operation-list.model';

export default class GetPaymentOperationListRequest extends ApiResourceMethod<PaymentOperationListItem[]> {
  public perform(): Promise<PaymentOperationListItem[]> {
    return this.performer.requestWithMapper(
      {},
      (payload: BaseResponse<PaymentOperationListItem[]>) => {
        return payload.data;
      },
    );
  }
}
